// 基础配置
const links = () => import('@/components/platform/website/link/index'); //友情链接
const sitemap = () => import('@/components/platform/website/sitemap/index'); //sitemap管理
const column = () => import('@/components/platform/website/column/index'); //栏目管理

const menu = () => import('@/components/websiteDeploy/menu/index/') // 菜单配置

const serviceAddress = () => import('@/components/websiteDeploy/serviceAddress/index/') // 服务网点
// 内容管理
const carousel = () => import('@/components/websiteDeploy/carousel/index'); // 官网配置//轮播配置
const casus = () => import('@/components/websiteDeploy/casus/index'); //客户案例
const recruit = () => import('@/components/websiteDeploy/recruit/index'); //招聘信息
const cooperation = () => import('@/components/websiteDeploy/cooperation/index'); //合作伙伴

const newsManage = () => import('@/components/websiteDeploy/news/index'); // 资讯管理
const infoModify = () => import('@/components/websiteDeploy/news/components/modify');
const inforview = () => import('@/components/websiteDeploy/news/components/viewer');
// 合伙人
const partner = () => import('@/components/websiteDeploy/partner/index/') // 合伙人加盟

// 学堂咨询管理  
const infoSchool = () => import('@/components/school/news/components/modify');






export default [{
    path: '/infoSchool',
    name: 'infoSchool',
    meta: {
      belong: ['website'],
      text: '新增咨讯',
    },
    component: infoSchool,
  },
  {
    path: '/links',
    name: 'links',
    meta: {
      belong: ['website'],
      text: '友情链接',
    },
    component: links,
  },
  {
    path: '/sitemap',
    name: 'sitemap',
    meta: {
      belong: ['website'],
      text: 'sitemap管理',
    },
    component: sitemap,
  },
  {
    path: '/column',
    name: 'column',
    meta: {
      belong: ['website'],
      text: '栏目管理',
    },
    component: column,
  },

  {
    path: '/carousel',
    name: 'carousel',
    meta: {
      belong: ['website'],
      text: '轮播配置',
    },
    component: carousel,
  },
  {
    path: '/casus',
    name: 'casus',
    meta: {
      belong: ['website'],
      text: '客户案例',
    },
    component: casus,
  },
  {
    path: '/recruit',
    name: 'recruit',
    meta: {
      belong: ['website'],
      text: '招聘信息',
    },
    component: recruit,
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    meta: {
      belong: ['website'],
      text: '合作伙伴',
    },
    component: cooperation,
  },
  {
    path: "/newsManage",
    name: "newsManage",
    component: newsManage,
    meta: {
      belong: ['website'],
      text: '资讯报道'
    }
  },
  {
    path: "/inforview",
    name: "inforview",
    component: inforview,
    meta: {
      belong: ['website'],
      text: '资讯预览'
    }
  },
  {
    path: "/infoModify",
    name: "infoModify",
    component: infoModify,
    meta: {
      belong: ['website'],
      text: '新闻资讯'
    }
  },
  {
    path: "/menu",
    name: "menu",
    component: menu,
    meta: {
      belong: ['website'],
      text: '菜单配置'
    }
  },
  {
    path: "/partner",
    name: "partner",
    component: partner,
    meta: {
      belong: ['website'],
      text: '合伙人加盟'
    }
  },
  {
    path: "/serviceAddress",
    name: "serviceAddress",
    component: serviceAddress,
    meta: {
      belong: ['website'],
      text: '服务网点'
    }
  },
];
